import { createContext, useContext } from 'react'

import type { User } from 'firebase/auth'

export type AuthStatus = 'checking' | 'signed-out' | 'signed-in'

export interface AuthState {
  status: AuthStatus
  user: User | null
}

export const AuthContext = createContext<AuthState>({ status: 'checking', user: null })

export function useAuth(): AuthState {
  return useContext(AuthContext)
}

/// Пользователь, который точно есть: внутри оболочки без входа не оказаться.
export function useAdminUser(): User {
  const { user } = useAuth()
  if (!user) throw new Error('useAdminUser вызван вне авторизованной части приложения')
  return user
}
